module.exports = __webpack_public_path__ + "static/BT-desktop-11-a0d565d3a08810b0f2d7d2c3dc6b5831.jpg";